var exports = {
  "kL": "ChannelSourcePreview.module__container___ajByX1",
  "FS": "ChannelSourcePreview.module__textContainer___ajByX1",
  "S7": "ChannelSourcePreview.module__nameRow___ajByX1",
  "p": "ChannelSourcePreview.module__channelIcon___ajByX1",
  "oo": "ChannelSourcePreview.module__nameButton___ajByX1",
  "fh": "ChannelSourcePreview.module__nameText___ajByX1",
  "W$": "ChannelSourcePreview.module__subtext___ajByX1",
  "HR": "ChannelSourcePreview.module__subtextMuted___ajByX1",
  "G4": "ChannelSourcePreview.module__subtextPrimary___ajByX1",
  "XW": "ChannelSourcePreview.module__subtextBreadcrumb___ajByX1",
  "$T": "ChannelSourcePreview.module__subtextChevron___ajByX1",
  "my": "ChannelSourcePreview.module__avatar___ajByX1",
  "YQ": "ChannelSourcePreview.module__fallbackIcon___ajByX1",
  "bo": "ChannelSourcePreview.module__focusRingTight___ajByX1",
};

module.exports = exports;
